import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

import { IconSpriteModule } from '@personal-area/icon-sprite';

import { DepositBonusTrackingService } from '../services/deposit-bonus-tracking.service';

@Component({
  templateUrl: './deposit-bonus-withdrawal-terms-dialog.component.html',
  styleUrls: ['./deposit-bonus-withdrawal-terms-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, TranslateModule, IconSpriteModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepositBonusWithdrawalTermsDialogComponent implements OnInit {
  constructor(
    private readonly _depositBonusTrackingService: DepositBonusTrackingService,
  ) {}

  ngOnInit(): void {
    this._depositBonusTrackingService.termsDepositBonusViewed();
  }
}
